import React, { Component } from 'react';
import range from 'lodash/range';
import {
	Pagination,
	PaginationItem,
	PaginationLink,
} from 'reactstrap';

import './paginationlist.css';

class PaginationList extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
	}

	isPaginationVisible = () => this.props.totalPages > 1;

	changePaginateItem = event => {
		event.preventDefault();
		this.props.setCurrentPage(+event.target.dataset.page);
	};

	backPaginatedList = event => {
		event.preventDefault();
		if (this.props.currentPage !== 0) {
			this.props.setCurrentPage(this.props.currentPage - 1);
			if (this.props.currentPage - 1 < this.props.paginatedList[0]) {
				const newRange = range(
					this.props.paginatedList[0] !== 0 ? this.props.paginatedList[0] - 1 : 0,
					this.props.paginatedList[this.props.paginatedList.length - 1]
				);
				this.props.setPaginatedList(newRange);
			}
		}
	};

	forwardPaginatedList = event => {
		event.preventDefault();
		if (this.props.currentPage < this.props.totalPages - 1) {
			this.props.setCurrentPage(this.props.currentPage + 1);
			if (this.props.currentPage + 1 > this.props.paginatedList[this.props.paginatedList.length - 1]) {
				const newRange = range(
					this.props.paginatedList[0] + 1,
					this.props.paginatedList[this.props.paginatedList.length - 1] + 2
				);
				this.props.setPaginatedList(newRange);
			}
		}
	};

	render() {
		const items = this.props.paginatedList.map((item, index) => (
			<PaginationItem key={index} active={this.props.currentPage === item} onClick={this.changePaginateItem}>
				<PaginationLink href="#" data-page={item}>
					{item + 1}
				</PaginationLink>
			</PaginationItem>
		));
		return (
			<Pagination aria-label="Page navigation example"
						className={this.isPaginationVisible() ? 'pagination pagination_visible' : 'pagination pagination_invisible'}>
				<PaginationItem
					disabled={this.props.currentPage === 0}
					onClick={this.backPaginatedList}
				>
					<PaginationLink previous href="#"/>
				</PaginationItem>
				{items}
				<PaginationItem
					onClick={this.forwardPaginatedList}
					disabled={this.props.currentPage === this.props.totalPages - 1}
				>
					<PaginationLink next href="#"/>
				</PaginationItem>
			</Pagination>
		);
	}
}

export default PaginationList;



// WEBPACK FOOTER //
// ./src/components/PaginationList/PaginationList.js